(function () {
    'use strict';

    // Conditional console logging (only on development and staging domains)
    const isLocalOrStaging = window.location.hostname === 'localhost' || 
                             window.location.hostname === '127.0.0.1';

    function log(...args) {
        if (isLocalOrStaging && typeof console !== 'undefined' && typeof console.log === 'function') {
            console.log(...args);
        }
    }

    log('Main script loaded');

    // --- Product matching ---

    /**
     * Score a product against the selected filters.
     * Each matching criterion scores 1 point (max 3).
     */
    function scoreProduct(product, hectares, crop, power, companytype) {
        var score = 0;
        var match = product.match;
        if (hectares    && match.hectares.indexOf(hectares)        !== -1) score++;
        if (crop        && match.crop.indexOf(crop)                !== -1) score++;
        if (power       && match.power.indexOf(power)              !== -1) score++;
        if (companytype && match.companytype.indexOf(companytype)  !== -1) score++;
        return score;
    }

    function findBestMatch(products, rules, hectares, crop, power, companytype) {
        // Check explicit rules first (exact 4-key lookup)
        if (rules && rules.length) {
            for (var i = 0; i < rules.length; i++) {
                var rule = rules[i];
                if (rule.companytype === companytype &&
                    rule.hectares   === hectares     &&
                    rule.crop       === crop         &&
                    rule.power      === power) {
                    for (var j = 0; j < products.length; j++) {
                        if (products[j].id === rule.product) return products[j];
                    }
                }
            }
        }
        // Fall back to score-based matching
        var best = null;
        products.forEach(function (product) {
            var score = scoreProduct(product, hectares, crop, power, companytype);
            if (score === 4) {
                best = product;
            }
        });
        return best;
    }

    function buildGallery(product) {
        var container = document.getElementById('result-gallery');
        if (!container) return;

        container.innerHTML = '';

        var images = product.images || [];
        if (images.length === 0) return;

        // First image — always visible
        var main = document.createElement('img');
        main.src = images[0];
        main.alt = product.name;
        main.className = 'card-img mb-small';
        container.appendChild(main);

        // Additional thumbnails (if any)
        if (images.length > 1) {
            var thumbs = document.createElement('div');
            thumbs.className = 'd-flex flex-wrap justify-content-center';
            thumbs.style.gap = '.5rem';

            images.forEach(function (src, index) {
                var thumb = document.createElement('img');
                thumb.src = src;
                thumb.alt = product.name + ' ' + (index + 1);
                thumb.style.cssText = 'width:5rem;height:3.5rem;object-fit:cover;cursor:pointer;border:2px solid transparent;';
                if (index === 0) thumb.style.borderColor = 'var(--ae-secondary)';

                thumb.addEventListener('click', function () {
                    main.src = src;
                    thumbs.querySelectorAll('img').forEach(function (t) {
                        t.style.borderColor = 'transparent';
                    });
                    thumb.style.borderColor = 'var(--ae-secondary)';
                });

                thumbs.appendChild(thumb);
            });

            container.appendChild(thumbs);
        }
    }

    function populateHiddenFields(product, hectares, crop, power, companytype) {
        // lid from product JSON
        var lidField = document.getElementById('lid');
        if (lidField && product.lid) {
            lidField.value = product.lid;
        }

        // notes: label + selected value for each select, then product name
        var notesField = document.getElementById('notes');
        if (notesField) {
            var hectaresLabel    = document.querySelector('label[for="select-hectares"]');
            var cropLabel        = document.querySelector('label[for="select-crop"]');
            var powerLabel       = document.querySelector('label[for="select-power"]');
            var companytypeLabel = document.querySelector('label[for="companytype"]');

            var hectaresText = null, cropText = null, powerText = null, companytypeText = null;
            try {
                hectaresText    = document.querySelector('#select-hectares option[value="'  + hectares    + '"]');
                cropText        = document.querySelector('#select-crop option[value="'      + crop        + '"]');
                powerText       = document.querySelector('#select-power option[value="'     + power       + '"]');
                companytypeText = document.querySelector('#companytype option[value="'    + companytype + '"]');
            } catch (e) { /* invalid selector — fall back to raw values */ }

            var lines = [
                (hectaresLabel    ? hectaresLabel.textContent.trim()    : 'Ettari')       + ': ' + (hectaresText    ? hectaresText.textContent.trim()    : hectares),
                (cropLabel        ? cropLabel.textContent.trim()        : 'Coltura')      + ': ' + (cropText        ? cropText.textContent.trim()        : crop),
                (powerLabel       ? powerLabel.textContent.trim()       : 'Potenza')      + ': ' + (powerText       ? powerText.textContent.trim()       : power),
                (companytypeLabel ? companytypeLabel.textContent.trim() : 'Tipo azienda') + ': ' + (companytypeText ? companytypeText.textContent.trim() : companytype),
                'Prodotto consigliato: ' + product.nameForDealer
            ];

            notesField.value = lines.join('; \n');
        }
    }

    function goBackToQuiz(section) {
        var quiz = document.getElementById('quiz-section');
        section.classList.add('d-none');
        document.getElementById('form-section').classList.add('d-none');
        document.getElementById('result-voucher').classList.remove('d-none');
        // Hide grecaptcha badge when form becomes hidden
        var badge = document.querySelector('.grecaptcha-badge');
        if (badge) {
            badge.style.visibility = 'hidden';
        }
        if (quiz) {
            quiz.classList.remove('d-none');
            quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    function showNoResult() {
        var quiz = document.getElementById('quiz-section');
        if (quiz) quiz.classList.add('d-none');

        var section = document.getElementById('no-result-section');
        if (!section) return;
        section.classList.remove('d-none');
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });

        var retryBtn = document.getElementById('btn-retry');
        if (retryBtn) {
            retryBtn.addEventListener('click', function () {
                goBackToQuiz(section);
            }, { once: true });
        }
    }

    function showResult(product, hectares, crop, power, companytype) {
        var section = document.getElementById('result-section');
        var nameEl  = document.getElementById('result-name');
        var descEl  = document.getElementById('result-description');
        var linkEl  = document.getElementById('result-link');

        if (!section || !product) return;

        buildGallery(product);
        nameEl.textContent = product.name;
        descEl.textContent = product.description;
        linkEl.href = (/^https?:\/\//i.test(product.link)) ? product.link : '#';

        populateHiddenFields(product, hectares, crop, power, companytype);

        var quiz = document.getElementById('quiz-section');
        if (quiz) quiz.classList.add('d-none');

        section.classList.remove('d-none');
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });

        var voucherBtn = document.getElementById('result-voucher');
        var formSection = document.getElementById('form-section');
        if (voucherBtn && formSection) {
            voucherBtn.addEventListener('click', function () {
                voucherBtn.classList.add('d-none');
                formSection.classList.remove('d-none');
                formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                // Show grecaptcha badge when form becomes visible
                var badge = document.querySelector('.grecaptcha-badge');
                if (badge) {
                    badge.style.visibility = 'visible';
                }
            }, { once: true });
        }

        var retryResultBtn = document.getElementById('btn-retry-result');
        if (retryResultBtn) {
            retryResultBtn.addEventListener('click', function () {
                goBackToQuiz(section);
            }, { once: true });
        }
    }

    function initFinder(products, rules) {
        var btn     = document.getElementById('btn-find');
        var selects = [
            document.getElementById('select-hectares'),
            document.getElementById('select-crop'),
            document.getElementById('select-power'),
            document.getElementById('companytype')
        ];

        if (!btn) return;

        function updateButtonState() {
            var allSelected = selects.every(function (s) { return s && s.value !== ''; });
            btn.disabled = !allSelected;
        }

        // Sync companytype text into hidden field
        var companytypeSelect = document.getElementById('companytype');
        var companytypeText   = document.getElementById('companytypetext');
        var companytypeCode   = document.getElementById('companytypecode');
        if (companytypeSelect) {
            companytypeSelect.addEventListener('change', function () {
                var opt = companytypeSelect.options[companytypeSelect.selectedIndex];
                if (companytypeText) companytypeText.value = opt ? opt.text  : '';
                if (companytypeCode) companytypeCode.value = opt ? opt.value : '';
            });
        }

        // Disable on init, then watch changes
        updateButtonState();
        selects.forEach(function (s) {
            if (s) s.addEventListener('change', updateButtonState);
        });

        btn.addEventListener('click', function () {
            var hectares    = document.getElementById('select-hectares').value;
            var crop        = document.getElementById('select-crop').value;
            var power       = document.getElementById('select-power').value;
            var companytype = document.getElementById('companytype').value;

            log('Selection:', { hectares: hectares, crop: crop, power: power, companytype: companytype });

            var match = findBestMatch(products, rules, hectares, crop, power, companytype);
            log('Best match:', match);

            if (!match) {
                showNoResult();
            } else {
                showResult(match, hectares, crop, power, companytype);
            }
        });
    }

    // --- Init ---

    function init() {
        var el = document.getElementById('copyright');
        if (el) {
            el.innerHTML = el.innerHTML.replace('{year}', new Date().getFullYear());
        }

        // Load products and initialise the finder
        fetch('content/data/products.json')
            .then(function (res) { return res.json(); })
            .then(function (data) { initFinder(data.products, data.rules || []); })
            .catch(function (err) { log('Could not load products.json:', err); });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();